import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogComponent } from './dialog.component';
import { IconModule } from '@pc-ui/icon';
import { ButtonModule } from '@pc-ui/button';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [DialogComponent],
  imports: [CommonModule, IconModule, ButtonModule, MatDialogModule],
  exports: [DialogComponent],
})
export class DialogModule {}
